import { render, staticRenderFns } from "./PageAccounts.vue?vue&type=template&id=27df246a&"
import script from "./PageAccounts.vue?vue&type=script&lang=js&"
export * from "./PageAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27df246a')) {
      api.createRecord('27df246a', component.options)
    } else {
      api.reload('27df246a', component.options)
    }
    module.hot.accept("./PageAccounts.vue?vue&type=template&id=27df246a&", function () {
      api.rerender('27df246a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/PageAccounts.vue"
export default component.exports